package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_un_attimo_1
import gero.composeapp.generated.resources.exp_content_un_attimo_2
import gero.composeapp.generated.resources.exp_content_un_attimo_3
import gero.composeapp.generated.resources.exp_content_un_attimo_4
import gero.composeapp.generated.resources.exp_content_un_attimo_5
import gero.composeapp.generated.resources.exp_content_un_attimo_6
import gero.composeapp.generated.resources.exp_content_un_attimo_7
import gero.composeapp.generated.resources.exp_content_un_attimo_8
import gero.composeapp.generated.resources.exp_content_un_attimo_9
import gero.composeapp.generated.resources.exp_content_un_attimo_10
import gero.composeapp.generated.resources.exp_content_un_attimo_11
import gero.composeapp.generated.resources.exp_title_un_attimo

// New signs introduced before the chapter's name-reading practice.
val unAttimoHieroCodes = listOf("U33", "N24", "N42", "U28", "D1", "V30")

// Already-taught signs, used only to pad the quiz to 10 questions and as
// extra pronunciation distractors - not re-taught here.
private val unAttimoReviewHieroCodes = listOf(
    "G17", "N35", "Q3", "X1", "G43", "S29", "V28", "U1", "D4", "D2", "O1", "N5", "F34"
)

fun getUnAttimoContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_1,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_2,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_3,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_5,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_7,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_10,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_attimo,
            content = Res.string.exp_content_un_attimo_11,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )

    return intro + unAttimoHieroCodes.toHieroExplanation(hiero, languageCode)
}

fun getUnAttimoQuizContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IQuizContent> {
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getUnAttimoContent(hiero, languageCode),
        languageCode = languageCode,
        previousHieroContent = unAttimoReviewHieroCodes.toHieroExplanation(hiero, languageCode)
    )
}
